module.exports = __webpack_public_path__ + "static/media/pending_actions_agreement_claims_icon.4860bd80.svg";